import React from 'react';
import PropTypes from 'prop-types';
import PricePerMeter from '../../../Utils/PricePerMeter/PricePerMeter.jsx';
import { calculateDeltaInPercent } from '../../../../utils/NumbersHelper.js';
import styles from '../../../Utils/Widget/Widget.less';

export default class PriceHistoryWidgetRange extends React.Component {
  renderPoint = (pricePoint) => (
    <>
      <div className={`${styles.quarterLabel}`}>
        Q{pricePoint.quarter} {pricePoint.year}
      </div>
      <PricePerMeter
        price={pricePoint.price}
        color="#333333"
        commercializationType={this.props.commercializationType}
        appearance="large"
      />
    </>
  );

  renderPercentTag(from, to) {
    const percent = Math.round(calculateDeltaInPercent(from.price, to.price));
    return (
      <>
        <div className={`padding-bottom-s ${styles.quarterLabel}`}>
          zu Q{from.quarter} {from.year}
        </div>
        <div className={styles.percentTag}>
          <span className="padding-left-s padding-right-xs">
            <i className="is24-icon-statistics" />
          </span>
          <span>{`${percent < 0 ? '' : '+'}${percent}%`}</span>
        </div>
      </>
    );
  }

  render() {
    const { from, to } = this.props;

    return (
      <div className={styles.rangeBorder}>
        <div className={`priceRangeFrom inline-block padding-right-m align-top ${styles.verticalBorder}`}>
          {this.renderPoint(to)}
        </div>
        <div className="priceRangeTo inline-block padding-left-m align-top padding-right-m">
          {this.renderPercentTag(from, to)}
        </div>
      </div>
    );
  }
}

const pricePoint = PropTypes.shape({
  year: PropTypes.number.isRequired,
  quarter: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
});

PriceHistoryWidgetRange.propTypes = {
  from: pricePoint.isRequired,
  to: pricePoint.isRequired,
  commercializationType: PropTypes.string.isRequired,
};
